// workspaceAuthPaths.js — workspace rail routes that own their own auth UI

/**
 * True when the current path is the Workspace Docs sidebar rail.
 *
 * @param {string} pathname
 * @returns {boolean}
 */
export function isWorkspaceSidebarPath(pathname = '') {
  return String(pathname || '').startsWith('/workspace/sidebar');
}
